import { campusNews } from "../../data/resourcesData";
import ResourceHero from "./ResourceHero";
import "../../css/CampusNews.css";

export default function CampusNews() {
  return (
    <>
      <ResourceHero
        title="Campus News"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds3.png"
      />

      <section className="section campus-news-section" id="campus-news">
        <div className="container">

          <div className="resources-heading-row">
            <div>
              <span className="eyebrow">
                SCHOOL UPDATES
              </span>

              <h2 className="resources-heading">
                Campus News
              </h2>

              <p className="text-lead">
                Discover the latest activities, achievements,
                announcements and inspiring stories from Sahara
                Public School.
              </p>
            </div>
          </div>


          <div className="resources-card-grid">

            {campusNews.map((news, index) => (
              <article
                key={index}
                className="resources-news-card"
              >

                <img
                  src={news.image}
                  alt={news.title}
                  className="resources-news-image"
                />

                <div className="resources-news-content">

                  <div className="resources-meta">
                    <span>
                      {news.author}
                    </span>

                    <span>
                      {news.date}
                    </span>
                  </div>


                  <h3>
                    {news.title}
                  </h3>


                  <p>
                    {news.excerpt}
                  </p>


                </div>

              </article>
            ))}

          </div>

        </div>
      </section>
            <section className="section campus-life-section">

        <div className="container campus-life-wrapper">

          <div className="campus-life-image">

            <img
              src="/images/f.jpeg"
              alt="Campus Life"
            />

          </div>


          <div className="campus-life-content">

            <span className="eyebrow">
              CAMPUS LIFE
            </span>


            <h2>
              Experience Learning Beyond The Classroom
            </h2>


            <p className="text-lead">
              Sahara Public School provides a vibrant campus
              where students participate in academics, sports,
              cultural activities and leadership programmes
              that encourage holistic development.
            </p>


            <ul>

              <li>
                Academic & Cultural Events
              </li>


              <li>
                Sports Competitions
              </li>


              <li>
                Science & Innovation Activities
              </li>


              <li>
                Community Engagement
              </li>


              <li>
                Student Leadership Programmes
              </li>


            </ul>


          </div>

        </div>

      </section>
            <section className="section campus-highlight-section">

        <div className="container">

          <div className="section-heading">

            <span className="eyebrow">
              HIGHLIGHTS
            </span>


            <h2>
              Explore Campus Activities
            </h2>


            <p className="text-lead">
              Discover the exciting programmes and events
              that make our school community vibrant and engaging.
            </p>


          </div>


          <div className="campus-highlight-grid">


            <div className="campus-highlight-card">

              <h3>
                Annual Function
              </h3>

              <p>
                Celebrating student talent through cultural
                performances, creativity and achievements.
              </p>

            </div>



            <div className="campus-highlight-card">

              <h3>
                Sports Day
              </h3>

              <p>
                Encouraging teamwork, discipline, leadership
                and physical fitness among students.
              </p>

            </div>



            <div className="campus-highlight-card">

              <h3>
                Science Exhibition
              </h3>

              <p>
                Innovative student projects showcasing creativity,
                research and problem-solving skills.
              </p>

            </div>



            <div className="campus-highlight-card">

              <h3>
                Educational Tours
              </h3>

              <p>
                Practical learning experiences through visits,
                field trips and real-world exposure.
              </p>

            </div>


          </div>

        </div>

      </section>

    </>
  );
}